import "./polyfills"; // For IE 11 support
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "react-apollo";
import { AuthProvider } from "./lib/auth";
import apolloClient from "./ApolloClient";
import "bootstrap/dist/css/bootstrap.css";
import "react-instantsearch-theme-algolia/style.css";
import "./index.css";
import App from "./components/App";
import RaygunUser from "./Raygun";
import { unregister } from "./registerServiceWorker";
import RouteChangeHandler from "./lib/Segment/RouteChangeHandler";

// Add global error handler for Google Maps API errors
window.addEventListener("unhandledrejection", (event) => {
  // Check if the error is related to Google Maps IntersectionObserver
  if (
    event.reason &&
    event.reason.message &&
    (event.reason.message.includes("IntersectionObserver.observe") ||
      event.reason.message.includes("must be an instance of Element"))
  ) {
    // eslint-disable-next-line no-console
    console.warn(
      "Google Maps IntersectionObserver error caught and prevented:",
      event.reason.message
    );
    event.preventDefault(); // Prevent the error from propagating
    return false;
  }
});

// Handle Google Maps API script errors
window.addEventListener("error", (event) => {
  if (event.filename && event.filename.includes("maps.googleapis.com")) {
    console.warn("Google Maps API error caught:", event.error || event.message); // eslint-disable-line no-console
    event.preventDefault();
    return false;
  }
});

ReactDOM.render(
  <ApolloProvider client={apolloClient}>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <AuthProvider>
        <App />
        <RouteChangeHandler />
        <RaygunUser />
      </AuthProvider>
    </BrowserRouter>
  </ApolloProvider>,
  document.getElementById("root")
);
unregister();
